setInterval(() => {
    window.location.reload();
}, 3600000); // 1時間ごとにリロード（3600000ミリ秒）

//===========================================================
  //slider
  //===========================================================
  const mySwiper = new Swiper('.swiper', {
    loop: true,
    speed:1000,
    slidesPerView:1,
    centeredSlides : true, 
    breakpoints: {
      768: {
        slidesPerView: 1.3,
      }
    },
    pagination: {
      el: '.swiper-pagination',
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: false // 矢印をクリックしても自動再生を止めない
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  
  const mySwiper2 = new Swiper('.swiper2', {
    loop: true,
    speed:500,
    spaceBetween: 20,
    slidesPerView:1.5,
    centeredSlides : true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: '.swiper-pagination',
    },
  
    autoplay: {
      delay: 3000,
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  
  const mySwiper3 = new Swiper('.swiper3', {
    loop: true,
    speed:500,
    spaceBetween: 20,
    slidesPerView:1.5,
    centeredSlides : true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: '.swiper-pagination',
    },
  
    autoplay: {
      delay: 3000,
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

//   $(window).on('load', function(){
//     setTimeout(function(){
//     $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').addClass('c_none');
//   },1000);
//     $("#CART .check").click(function () {
//       if ($("#CART .check").prop("checked") == true) {
//         $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').removeClass('c_none');
//       } else {
//         $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').addClass('c_none');
//       }
//   }); 
// });

$(document).ready(function() {
    $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').addClass('c_none');
  });
  
  $(function () {
    //===========================================================
    // 期間限定表示
    //===========================================================
    // const now = new Date();
    // const start = new Date('2023/4/26 7:00:00'); // 表示開始日時（時間は24h表記）
    // const end = new Date('2023/5/2 12:00:00'); // 表示終了日時（時間は24h表記）
    // if ( start <  now && now < end ) {
    //     document.getElementById("timeLimitedScript").style.display="block";
    // }
    //===========================================================
    // 読み込み時のページ崩れ防止
    //===========================================================
    $('#shopify-section-header header').fadeIn(500);
    $('#shopify-section-header header h1').fadeIn(600);
    $('#OKAWARI section.sec01').fadeIn(0);
    $('main').fadeIn(0);
    $('#shopify-section-footer footer').fadeIn(0);

    //===========================================================
    // input欄タイプnumber時のスクロールイベント阻止
    //===========================================================
    $('form').on('focus', 'input[type=number]', function (e) {
    $(this).on('wheel.disableScroll', function (e) {
      e.preventDefault()
      })
    })
    $('form').on('blur', 'input[type=number]', function (e) {
      $(this).off('wheel.disableScroll')
    })
    
    //===========================================================
    // スマホかPCかの判別
    //===========================================================
    const userAgent = window.navigator.userAgent.toLowerCase();
    let isPc = false;
    if (
        userAgent.indexOf("iphone") != -1 ||
        userAgent.indexOf("ipad") != -1 ||
        userAgent.indexOf("android") != -1 ||
        userAgent.indexOf("mobile") != -1
      ) {
        isPc = false;
      } else {
        isPc = true;
      }

    //===========================================================
    // 商品購入はこちらボタンをスクロール時に下部に固定（トップページ）
    //===========================================================
    $(window).on("scroll", function() {
      const scrollHeight = $(document).height();/*ページ全体の高さ*/
      const scrollPosition = $(window).height() + $(window).scrollTop();/*ページの一番上からスクロールされた距離*/
      const footHeight = $("footer").height();/*フッターの高さ*/
      if (((isPc && $(this).scrollTop() > 1000) || (!isPc && $(this).scrollTop() > 400)) && !(scrollHeight - scrollPosition  <= Number(footHeight + 450) ) ) {
          // $(".float_btn_area").fadeIn(300);
          $(".float_btn_area").removeClass('d_none');
          $(".float_btn_area").removeClass('fadeOut');
          $(".float_btn_area").addClass('fadeIn');
      } else {
          // $(".float_btn_area").fadeOut(300);
          $(".float_btn_area").removeClass('fadeIn');
          $(".float_btn_area").addClass('fadeOut');
      }
    });

    //===========================================================
    // プライバシーポリシーのチェック時の購入ボタンの活性、非活性制御（カートページ）
    //===========================================================
    $(document).on('click','.check',function() {
      if ($("#CART .check").prop("checked") == true) {
        $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').removeClass('c_none');
      } else {
        $('#CART .cart__checkout-button, #CART .cart__footer .shopify-cleanslate ul li').addClass('c_none');
      }
    });

  
    //===========================================================
    //menu
    //===========================================================
    $('.nav_toggle').on('click', function () {
      $(".nav_toggle").toggleClass('open');
      $("header nav .nav_list").fadeToggle(300);
    });
    if ($(window).width() < 768) {
    $('header .nav_list li a').on('click', function () {
      $(".nav_toggle").removeClass('open');
      $("header nav .nav_list").fadeOut(300);
    });
    }
  
    //===========================================================
    //tab
    //===========================================================
    $('.tab_list li').on('click', function () {
      $('.active').removeClass('active');
      $(this).addClass('active');
      $('.show').removeClass('show');
      const index = $(this).index();
      $('.panel').eq(index).addClass('show');
    });
  
    //===========================================================
    //accordion
    //===========================================================
    $('#TOP .sec10 dl dt').on('click', function () {
      $(this).toggleClass("active");
      $('#TOP .sec10 dl dt').not($(this)).next('dd').slideUp();
      $('#TOP .sec10 dl dt').not($(this)).removeClass("active");
      $(this).next('dd').stop().slideToggle(600 ,'easeOutExpo');
    });

    $('#faq .faq_list dl dt').on('click', function () {
      $(this).next().slideToggle();
    });

  $('.faq-wrap dt').on('click', function () {
      $(this).toggleClass("active");
      $('.faq-wrap dt').not($(this)).next('dd').slideUp();
      $('.faq-wrap dt').not($(this)).removeClass("active");
      $(this).next('dd').stop().slideToggle(600 ,'easeOutExpo');
    });

    //===========================================================
    //購入制限
    //===========================================================
    const pathName1= location.pathname;
    if(pathName1.includes('add-gb-japan') || pathName1.includes('globalshare100') || pathName1.includes('koreashare100') || pathName1.includes('americashare100') || pathName1.includes('taiwanshare100') || pathName1.includes('thaishare100') || pathName1.includes('vietnamshare100')) {
      $(".okawari .product-form__submit").prop('disabled', true);
    }

    //===========================================================
    //IMEI番号必須
    //===========================================================
    $(".input_imei").on("input", async function() {
      $(".okawari .product-form__submit").prop('disabled', true);
      let inputNumber = $(this).val();//input に入力された文字を取得
      let inputLength = inputNumber.length; 
      console.log(inputNumber);
      if(inputLength == 15){ //もし文字が入っていれば
        const checkResult = await (await fetch(`https://okgffmskejwnx7qclibnv4tkfq0luohs.lambda-url.ap-northeast-1.on.aws/?imei=${inputNumber}`)).json();
        const gbsetImei =  checkResult.isGbset;
        const vendor = checkResult.vendor;
        
        const pathName= location.pathname;
        const searchName = location.search;
        if( pathName.includes('globalshare100') || pathName.includes('koreashare100') || pathName.includes('americashare100') || pathName.includes('taiwanshare100') || pathName.includes('thaishare100') || pathName.includes('vietnamshare100')) {
          
            if(gbsetImei == true && vendor == 'glocalnet') {
              $(".okawari .product-form__submit").prop('disabled', false); //disabled を無効にする＝ボタンが押せる
              $(".okawari .product-form__submit span").text('カートへ追加');
            } else {
              $(".okawari .product-form__submit").prop('disabled', true); //disabled を無効にする＝ボタンが押せる
              $(".okawari .product-form__submit span").text('NA01端末専用プランです。');
            }

        } else {
          console.log('else GB');
          if(gbsetImei == true) {
            $(".okawari .product-form__submit").prop('disabled', false); //disabled を無効にする＝ボタンが押せる
            $(".okawari .product-form__submit span").text('カートへ追加');
          } else {
            $(".okawari .product-form__submit").prop('disabled', true); //disabled を無効にする＝ボタンが押せる
            $(".okawari .product-form__submit span").text('ギガセット端末ではございません');
          }
        }
        
      }else{
        $(".okawari .product-form__submit").prop('disabled', true); //disabled を有効にする＝ボタンが押せない
        $(".okawari .product-form__submit span").text('15桁のIMEI番号を入力してください');
      }
  });
  
    //===========================================================
    //scroll
    //===========================================================
    var urlHash = location.hash;
    if (urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        var target = $(urlHash);
        if ($(window).width() > 768) {
          var position = target.offset().top - 69;
        } else {
          var position = target.offset().top - 59;
        }
        $('body,html').stop().animate({
          scrollTop: position
        }, 500);
      }, 100);
    }
  
    $(function () {
      $('a[href*="#"]').not(".noScroll, .jdgm-write-rev-link").click(function () {
  
        var speed = 400, // ミリ秒(この値を変えるとスピードが変わる)
          href = $(this).prop("href"), //リンク先を絶対パスとして取得
          hrefPageUrl = href.split("#")[0], //リンク先を絶対パスについて、#より前のURLを取得
          currentUrl = location.href, //現在のページの絶対パスを取得
          currentUrl = currentUrl.split("#")[0]; //現在のページの絶対パスについて、#より前のURLを取得
  
        //#より前の絶対パスが、リンク先と現在のページで同じだったらスムーススクロールを実行
        if (hrefPageUrl == currentUrl) {
  
          //リンク先の#からあとの値を取得
          href = href.split("#");
          href = href.pop();
          href = "#" + href;
  
          //スムースクロールの実装
          var target = $(href == "#" || href == "" ? 'html' : href);
          if ($(window).width() > 768) {
            var position = target.offset().top - 69;
          } else {
            var position = target.offset().top - 59;
          }
          $('body,html').stop().animate({
            scrollTop: position
          }, 500);
  
          return false;
        }
  
      });
    });
  });